// 시스템관리 - 시스템관리
import { Route, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';


const RSY50 = lazy(() => import('@/pages/D01/RSY50'));  // FAQ
const RSY51 = lazy(() => import('@/pages/D01/RSY51'));  // QNA
const RSY52 = lazy(() => import('@/pages/D01/RSY52'));  // FAQ
const GNGS  = lazy(() => import('@/pages/D01/GNGS'));

function D01() {
  return ( 
    <Suspense fallback={null}>
      <Switch>
        <Route path="/D01/RSY50" component={RSY50} />
        <Route path="/D01/RSY51" component={RSY51} />
        <Route path="/D01/RSY52" component={RSY52} />
        <Route path="/D01/GNGS"  component={GNGS} />
      </Switch>
    </Suspense>
  );
}

export default D01;
